import { render, staticRenderFns } from "./printPrescriptionImg.vue?vue&type=template&id=41d45b1c&scoped=true"
import script from "./printPrescriptionImg.vue?vue&type=script&lang=js"
export * from "./printPrescriptionImg.vue?vue&type=script&lang=js"
import style0 from "./printPrescriptionImg.vue?vue&type=style&index=0&id=41d45b1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d45b1c",
  null
  
)

export default component.exports